












































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationReviewStatus extends ApiAccessBase {
  private isReadMode: boolean = true;
  private dataCheckList: string[] = [];

  // 20240906 [02_審査状況履歴表示機能] morimoto ADD Start
  // 履歴番号と履歴番号の最大値
  private isRevNo: string = '';
  private isMaxRevNo: string = '';
  // ページの初期設定
  private page = 1;
  private pageCount = 0;
  // 20240906 [02_審査状況履歴表示機能] morimoto ADD End

  // 共通パス
  private APP_PATH = UketsukeConstants.APP_REVIEW_STATUS;

  private created() {
    this.screenTitle = '審査状況';
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;
    path = path + '/get/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        this.isReadMode = supervisingModule.IS_MODE_READ;
        // deep copy
        this.dataCheckList = JSON.parse(JSON.stringify(this.formData.reviewStatusFlg));
        // 20240906 [02_審査状況履歴表示機能] morimoto ADD Start
        // 履歴番号の最大値と画面表示用を取得
        this.isMaxRevNo = this.formData.revisionNo[0];
        this.isRevNo = this.formData.revisionNo[0];
        // ページ数を審査状況履歴の数に設定する
        this.pageCount = Number(this.isMaxRevNo);
        // 20240906 [02_審査状況履歴表示機能] morimoto ADD End
      }
    });
  }

  /**
   * 登録
   */
  private regist() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }

    let path = this.APP_PATH;
    path = path + '/put/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // 20240906 [02_審査状況履歴表示機能] morimoto ADD Start
    path = path + '/' + this.isMaxRevNo;
    // 20240906 [02_審査状況履歴表示機能] morimoto ADD End

    // 先頭へジャンプ
    this.hrefElement('review-status', -50);
    this.apiAccess(path, Constants.API_METHOD_POST, false, null).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          // deep copy
          this.dataCheckList = JSON.parse(JSON.stringify(this.formData.reviewStatusFlg));
        }
      },
    );
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    //排他の解除
    let path = this.APP_PATH;
    path = path + '/exclusive/delete/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    this.apiAccess(path, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 前画面に戻る
        router.push({name: UketsukeScreenName.APP_TRADER_SEARCH});
      }
    });
  }

  // 20240906 [02_審査状況履歴表示機能] morimoto ADD Start
  /**
   * 指定したページの審査状況を取得する
   */
  private selectReview() {
    this.getReviewStatus(String(Number(this.isMaxRevNo) - Number(this.page) + 1));
  }

  /**
   * 引数に設定した履歴番号から審査状況を取得する
   */
  private getReviewStatus(nextRevNo: string) {
    let path = this.APP_PATH;
    path = path + '/revisionget/' + applicationFormModule.GET_APP_TYPE;
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    path = path + '/' + nextRevNo + '/' + this.isMaxRevNo;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          //使用する可変項目の設定（全て）
          this.setAllVariablecolsState();
          this.isReadMode = supervisingModule.IS_MODE_READ;
          // deep copy
          this.dataCheckList = JSON.parse(JSON.stringify(this.formData.reviewStatusFlg));
          // 表示する履歴番号の更新
          this.isRevNo = this.formData.revisionNo[0];
        }
      });
    // 先頭へジャンプ
    this.hrefElement('applicationReviewStatus', -50);
  }
  // 20240906 [02_審査状況履歴表示機能] morimoto ADD End
}
